export const LocalStorageKeys = {
  SmartSendSetup: 'SMARTERSENDING-SETUP',
  SmartSendPreferredVersion: 'SMARTSEND-PREFERRED-VERSION',
  SmartSendPreviousPreferredVersion: 'SMARTSEND-PREVIOUS-PREFERRED-VERSION',
  HasVisitedSmartSend: 'HAS-VISITED-SMARTSEND',
  SmartSendOnboardingProgress: 'SMARTSEND-ONBOARDING-PROGRESS',
  MyProductsDefaultId: 'MY-PRODUCTS-DEFAULT-ID'
};
